import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Flex, Padding, Typography } from 'UI';
import { store } from './store';
import { ROUTES } from 'router';
import { useT } from 'hooks';
import { TEXT_COLOR } from '@styles';

const Container = styled.div<{ open: boolean }>`
	width: 100vw;
	height: 100vh;
	background: rgba(40, 40, 53, 0.7);
	position: fixed;
	z-index: 100;
	top: 0;
	left: 0;
	opacity: ${({ open }) => (open ? 1 : 0)};
	transition: 0.3s;
	pointer-events: ${({ open }) => (open ? 'all' : 'none')};
`;

const Content = styled.div<{ open: boolean }>`
	width: 210px;
	height: 100vh;
	background-color: ${({ theme }) => theme.colors.bg1};
	transform: translateX(-100%);
	transition: all 0.3s;

	${({ open }) =>
		open &&
		css`
			transform: translateX(0);
			transition: all 0.3s;
		`}
`;

const MenuItem = styled.div`
	padding: 10px 0;
	transition: opacity 0.3s;
	&:hover {
		filter: brightness(1.3);
	}
`;

export const SideMenu: FC = observer(() => {
	const { open, setOpen } = store;
	const { T } = useT();

	const handleHide = (): void => {
		setOpen(false);
	};

	const handleItemClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
		e.stopPropagation();
		handleHide();
	};

	return (
		<Container open={open} onClick={handleHide}>
			<Content open={open} onClick={e => e.stopPropagation()}>
				<Padding size={20} top={10}>
					<Flex direction='column' gap={10}>
						<Link to={ROUTES.HOME} onClick={handleItemClick}>
							<MenuItem>
								<Typography size={17} weight={700} color={TEXT_COLOR.TEXT6}>
									{T('menu_home')}
								</Typography>
							</MenuItem>
						</Link>

						<Link to={ROUTES.CONTACTS} onClick={handleItemClick}>
							<MenuItem>
								<Typography size={17} weight={700} color={TEXT_COLOR.TEXT6}>
									{T('menu_contacts')}
								</Typography>
							</MenuItem>
						</Link>

						<a
							href='https://verv.com/privacy-policy-main/'
							target='_blank'
							rel='noreferrer'
							onClick={handleItemClick}
						>
							<MenuItem>
								<Typography size={17} weight={700} color={TEXT_COLOR.TEXT6}>
									{T('menu_policy')}
								</Typography>
							</MenuItem>
						</a>

						<a
							href='https://verv.com/terms-conditions/'
							target='_blank'
							rel='noreferrer'
							onClick={handleItemClick}
						>
							<MenuItem>
								<Typography size={17} weight={700} color={TEXT_COLOR.TEXT6}>
									{T('menu_terms')}
								</Typography>
							</MenuItem>
						</a>
					</Flex>
				</Padding>
			</Content>
		</Container>
	);
});
